<template>
<div class="advanced-setting-view">
        <div class="delete-space">
            <span>{{$t("彻底删除知识库，删除后，所有内容将被删除，所有成员将无法访问。请谨慎操作！")}}</span>
            <div class="delete-btn" @click="deleteSpace">{{$t("删除知识库")}}</div>
        </div>
        <a-modal class="confirm-delete-dialog" v-model:visible="showConfirmDialog" :simple="true" :footer="false" @close="this.spaceName = ''">
            <div class="content">
                <div class="title">{{$t("删除知识库")}}</div>
                <div class="desc">{{$t("知识库删除后，所有内容将被删除，所有成员将无法访问。请谨慎操作！")}}                </div>
                <div class="input-tip">{{$t("请输入知识库名称以确认")}}</div>
                <a-input class="input-confirm" v-model="spaceName" :placeholder="defaultPlaceHolder" :max-length="100" @input="inputSpaceName"></a-input>
                <div class="bottom">
                    <div class="cancel-btn" @click="showConfirmDialog = false">{{$t("取消")}}</div>
                    <div class="confirm-btn" :class="{ 'disabled': spaceName !== defaultPlaceHolder }" @click="confirmDelete">{{$t("删除")}}</div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { deleteWikiSpace } from "../../core/api/setting";
import { mapActions, mapState } from "vuex";

export default {
  name: "AdvancedSettingView",
  data() {
    return {
      showConfirmDialog: false,
      spaceName: '' };

  },
  computed: {
    ...mapState({
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo }),

    defaultPlaceHolder() {
      return this.wikiSpaceInfo.wikiSpaceName;
    } },

  methods: {
    ...mapActions({
      setDocView: "kbModule/setDocView" }),

    deleteSpace() {
      this.showConfirmDialog = true;
    },
    inputSpaceName(val: string, ev: Event) {
    },
    confirmDelete() {
      deleteWikiSpace(this.wikiSpaceInfo.wikiSpaceId, this.spaceName).then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          this.showConfirmDialog = false;
          this.$message.success(intl.$t("删除知识库成功"));
          this.setDocView('empty');
        } else {
          this.$message.error(intl.$t(`删除失败，{message}`, { message: message }));
        }
      }).catch((err) => {
        this.$message.error(intl.$t("删除失败，请重试"));
      });
    } },

  created() {} };
</script>

<style lang="scss" scoped>
.advanced-setting-view {
    height: calc(100% - 94px);

    .delete-space {
        margin: 40px 24px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: nowrap;

        span {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #222329;
            line-height: 20px;
        }

        .delete-btn {
            margin-top: 16px;
            width: 94px;
            height: 32px;
            background: #ff4747;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 20px;
            cursor: pointer;

            &:hover {
                background: #ff5959;
                border-radius: 8px;
            }
        }
    }
}
</style>

<style lang="scss">
.confirm-delete-dialog {
    .arco-modal {
        width: 721px;
        background: #ffffff;
        border-radius: 16px;
        padding: 0;
        overflow: hidden;

        .arco-modal-header {
            margin-bottom: 0;
        }

        .arco-modal-body {
            overflow: hidden;
            width: 100%;
            height: 100%;

            .content {
                margin: 24px 24px 12px 24px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;

                .title {
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    font-size: 16px;
                    color: #121317;
                    letter-spacing: 0;
                    line-height: 22px;
                }

                .desc {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #323233;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin-top: 16px;
                }

                .input-tip {
                    margin-top: 26px;
                    margin-bottom: 6px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 12px;
                    color: #4E535C;
                    line-height: 20px;
                }

                .input-confirm {
                    background: #FFFFFF;
                    border: 1px solid #E8E9EE;
                    border-radius: 4px;
                    height: 32px;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #121317;
                    line-height: 20px;

                    &:focus-within {
                        border: 1px solid #5C70FF;
                        border-radius: 4px;
                    }
                }

                .bottom {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-top: 28px;
                    width: 100%;

                    .cancel-btn {
                        width: 76px;
                        height: 32px;
                        margin-right: 12px;
                        background: #FFFFFF;
                        border: 1px solid #E6E8EC;
                        border-radius: 8px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-family: PingFangSC-Medium;
                        font-weight: 500;
                        font-size: 14px;
                        color: #222329;
                        text-align: center;
                        line-height: 20px;

                        &:hover {
                            background: #F4F6F9;
                            border: 1px solid #E6E8EC;
                            border-radius: 8px;
                        }
                    }

                    .confirm-btn {
                        width: 76px;
                        height: 32px;
                        background: #FF4747;
                        font-family: PingFangSC-Medium;
                        font-weight: 500;
                        font-size: 14px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 20px;
                        border-radius: 8px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        &:hover {
                            background: #FF5959;
                            border-radius: 8px;
                        }
                    }

                    .confirm-btn.disabled {
                        width: 76px;
                        height: 32px;
                        background: #FFBDBD;
                        border-radius: 8px;
                        cursor: not-allowed;
                        pointer-events: none;
                    }
                }
            }
        }
    }
}
</style>
